import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter2.jsx';
import CrispMerchantStatusFilter from '../../filters/CrispMerchantStatusFilter.jsx';
import CrispMerchantGstNoFilter  from '../../filters/CrispMerchantGstNoFilter.jsx';
import CrispMerchantTradeNameFilter from '../../filters/CrispMerchantTradeNameFilter.jsx';
import CrispMerchantMobileFilter from '../../filters/CrispMerchantMobileFilter.jsx';
import KYCStatesFilter from '../../filters/KYCStatesFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('30', '0', '2020-02-01','0');
var LinkPKYCTable='';

class LinkPKYCReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchant_name: '',
            gst_no:'',
            merchant_mobile:'',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            merchant_status:"",
            download_limit:31,
            kyc_status:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "crisp_merchant_kyc_status_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");



        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        // Check if filters exist in localStorage (restore only on back button)
        const savedFilters = localStorage.getItem('link_pkyc_filters');
        console.log("savedFilters")
        console.log(savedFilters)
        if (savedFilters) {
            this.setState(JSON.parse(savedFilters), () => {
                this.get_filtered_link_kyc_report();
            });
            // Clear filters after restoring once
            localStorage.removeItem('link_pkyc_filters');
        } else {
            this.get_filtered_link_kyc_report();
        }

        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName + ' ' + jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email, 'live_transaction_dump_report', 'sparcs');
    }

    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }


    downLoadPkycReport (e){
        let filters = {
            merchant_status: this.state.merchant_status,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:'link_kyc_report',
            user_id: this.state.user_id,
            gst_no: this.state.gst_no,
            merchant_name: this.state.merchant_name,
            merchant_mobile: this.state.merchant_mobile,
            kyc_status: this.state.kyc_status,
            download: 1,
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/crisp_reports/merchant_pkyc','Merchant_PKYC_Report','60');

    }

    get_filtered_link_kyc_report() {
//         console.log(tableHeaders);
//         console.log(tableBody);
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            merchant_status:this.state.merchant_status,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'link_kyc_report',
            user_id: this.state.user_id,
            gst_no: this.state.gst_no,
            merchant_name: this.state.merchant_name,
            merchant_mobile: this.state.merchant_mobile,
            kyc_status: this.state.kyc_status
        };
        if ($.fn.DataTable.isDataTable('#LinkPKYCTable')) {
            $('#LinkPKYCTable').DataTable().clear().destroy();
        }

        LinkPKYCTable = $('#LinkPKYCTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "searching": false,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
//                 fixedColumns:   {
//                                 leftColumns: 0,
//                                 rightColumns: 2
//                             },
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/link-pkyc-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "Merchant Name" },
                    { "data": "Mobile" },
                    { "data": "GST Number" },
//                     { "data": "Zone" },
                    { "data": "State" },
                    { "data": "City" },
                    { "data": "Pin Code" },
                    { "data": "Merchant Status" },
                    { "data": "KYC Status" },
                    { "data": "Last Update Date" },
                    { "data": "GST Registration" },
                    { "data": "Aadhar" },
                    { "data": "Bank" },
                    { "data": "Request for PKYC" },
                    { "data": "Payment for PKYC" },
                    { "data": "PKYC Completed" },
                    { "data": "PKYC Archived at HO" },
                    { "data": "PKYC Process Time (QR to Final Approval)" },
                    { "data": "Percentage Completion" },
                    { "data": "uid" },
                    { "data": "uid" }
                    ],
                 "columnDefs": [
                   {
                    "width": "50px",
                    "className":"text-center",
                    "targets": 18,
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).text('');
                            $(td).append('<a href="#"  data-tip="View" title="View History" id="re_run"  class="RerunButton" >View</a>');
                            $(td).click(e => {
                                this.view_history1(e,rowData);
                            })
                    },
                    bSortable: false,
                },
                {
                    "width": "50px",
                     "className":"text-center",
                    "targets": 19,
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).text('');

                            $(td).append('<a href="#"  data-tip="View" title="View KYC Documents" id="re_run"  class="RerunButton" >View</a>');
                            $(td).click(e => {
                                this.view_history(e,rowData);
                            })

                    },
                    bSortable: false,
                }
               ],
            });


    }
    view_history(e, rowData){
//         var id = rowData.uid
//         const { history } = this.props;
//         history.push(`/admin/view-kyc-document/${id}`);
        var id = rowData.uid;
        var Merchant_Status = rowData["Merchant Status"]
        const { history } = this.props;

        // Save filters to localStorage
        localStorage.setItem('link_pkyc_filters', JSON.stringify({
            datefrom: this.state.datefrom,
            dateTo: this.state.dateTo,
            datefromShow: this.state.datefromShow,
            dateToShow: this.state.dateToShow,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            dateFromLimit: this.state.dateFromLimit,
            dateLimit: this.state.dateLimit,
            merchant_name: this.state.merchant_name,
            gst_no: this.state.gst_no,
            merchant_mobile: this.state.merchant_mobile,
            merchant_status: this.state.merchant_status
        }));

        history.push(`/admin/view-kyc-document/${id}?status=${encodeURIComponent(Merchant_Status)}`);
    }
    view_history1(e, rowData) {
        //console.log(rowData)
        var id = rowData.uid;
        var Merchant_Status = rowData["Merchant Status"]
        const { history } = this.props;

        // Save filters to localStorage
        localStorage.setItem('link_pkyc_filters', JSON.stringify({
            datefrom: this.state.datefrom,
            dateTo: this.state.dateTo,
            datefromShow: this.state.datefromShow,
            dateToShow: this.state.dateToShow,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            dateFromLimit: this.state.dateFromLimit,
            dateLimit: this.state.dateLimit,
            merchant_name: this.state.merchant_name,
            gst_no: this.state.gst_no,
            merchant_mobile: this.state.merchant_mobile,
            merchant_status: this.state.merchant_status
        }));

        history.push(`/admin/view-history/${id}?status=${encodeURIComponent(Merchant_Status)}`);
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.CrispMerchantStatusFilter.resetCrispMerchantStatusFilter();
        this.refs.CrispMerchantTradeNameFilter.fetchTradeNames();
        this.refs.CrispMerchantMobileFilter.fetchMobiles();
        this.refs.CrispMerchantGstNoFilter.fetchGstNumbers();
        this.refs.CrispKYCStatesFilter.getKYCStateList();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchant_status:'',
            merchant_name: '',
            merchant_mobile:'',
            gst_no:'',
            isChange: false,
            kyc_status:''

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleCrispMerchantStatusFilter = (optionSelected, event_names) =>
    {
        this.setState({
            merchant_status:event_names,
            isChange: true
        });
    }
    handleCrispMerchantGstNo= (optionSelected, event_names) =>
    {
        this.setState({
            gst_no:event_names,
            isChange: true
        });
    }
    handleCrispKYCStates= (optionSelected, event_names) =>
    {
        this.setState({
            kyc_status:event_names,
            isChange: true
        });
    }
    handleCrispMerchantMobileFilter= (optionSelected, event_names) =>
    {
        this.setState({
            merchant_mobile:event_names,
            isChange: true
        });
    }
    handleCrispTradeNameFilter= (optionSelected, event_names) =>
    {
        console.log("optionSelected")
        console.log(event_names)
        this.setState({
            merchant_name:event_names,
            isChange: true
        });
    }



    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Merchant KYC Status</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Merchant Status </label>
                                                <CrispMerchantStatusFilter ref="CrispMerchantStatusFilter" onSelectCrispMerchantStatus = {this.handleCrispMerchantStatusFilter} value={this.state.merchant_status}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Merchant Name </label>
                                                <CrispMerchantTradeNameFilter ref="CrispMerchantTradeNameFilter" onSelectCrispMerchantTradeName = {this.handleCrispTradeNameFilter} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Merchant Mobile </label>
                                                <CrispMerchantMobileFilter ref="CrispMerchantMobileFilter" onSelectCrispMerchantMobile = {this.handleCrispMerchantMobileFilter} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> GST Number </label>
                                                <CrispMerchantGstNoFilter ref="CrispMerchantGstNoFilter" onSelectCrispMerchantGstNo = {this.handleCrispMerchantGstNo} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> KYC States</label>
                                                <KYCStatesFilter ref="CrispKYCStatesFilter" onSelectKYCStates = {this.handleCrispKYCStates} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_link_kyc_report.bind(this)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>

                                        </div>

                                    </div>
                                    <div className="row">

                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton1" role="button" onClick={this.downLoadPkycReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="LinkPKYCTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant Name</th>
                                                <th>Mobile</th>
                                                <th>GST Registration</th>
{/*                                                 <th>Zone</th> */}
                                                <th>State</th>
                                                <th>City</th>
                                                <th>Pin Code</th>
                                                <th>Merchant Status</th>
                                                <th>KYC Status</th>
                                                <th>Last Update Date</th>
                                                <th>GST Registration</th>
                                                <th> Aadhar </th>
                                                <th>Bank  </th>
                                                <th>Request for PKYC</th>
                                                <th>Payment for PKYC</th>
                                                <th>PKYC Completed</th>
                                                <th>PKYC Archived at HO</th>
                                                <th>PKYC Process Time (QR to Final Approval)</th>
                                                <th>Percentage Completion</th>
                                                <th>View History</th>
                                                <th>KYC Document</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(LinkPKYCReport)